export const BOOK_A_DEMO_REQ = "BOOK_A_DEMO_REQ";
export const BOOK_A_DEMO_SUCCESS = "BOOK_A_DEMO_SUCCESS";
export const BOOK_A_DEMO_FAILED = "BOOK_A_DEMO_FAILED";
export const BOOK_A_DEMO_RESET = "BOOK_A_DEMO_RESET";

export const GET_BOOK_DETAILS_REQ = "GET_BOOK_DETAILS_REQ";
export const GET_BOOK_DETAILS_SUCCESS = "GET_BOOK_DETAILS_SUCCESS";
export const GET_BOOK_DETAILS_FAILED = "GET_BOOK_DETAILS_FAILED";
